export default __webpack_public_path__ + "static/media/style.d6cbaa32.less";